import { action } from 'mobx';
import moment from 'moment';
import { BasePreviewViewStore, BaasicDropdownStore } from 'core/stores';
import { applicationContext } from 'core/utils';
import { FacilityService } from 'application/facility/services';
import { ScheduleService } from 'application/schedule/services';
import { LookupService } from "common/services";
import { toUTCDate } from 'core/utils';
import _ from 'lodash';

@applicationContext
class FacilityPreviewViewStore extends BasePreviewViewStore {
    constructor(rootStore) {
        const id = rootStore.routerStore.routerState.params.id;
        const service = new FacilityService(rootStore.application.baasic.apiClient);

        super(rootStore, {
            name: 'facility-preview',
            autoInit: true,
            id: id,
            authorization: 'portalSection.update',
            routes: {
                edit: () => {
                    this.rootStore.routerStore.setTransitionData({ navigationTitle: this.item.name });
                    this.rootStore.routerStore.goTo('master.app.main.facility.edit', { id: this.id });
                },
                history: () => {
                    window.open(`${rootStore.routerStore.findRoute('master.app.main.facility.facility-history.list').pattern}?facilityId=${this.id}`);
                }
            },
            actions: () => {
                return {
                    get: async (id) => {
                        const response = await service.get(id, { embed: 'FacilityAreaOfCares,MainVendor,AccountRep,PurchaseRep,Branch,Corporate,Corporate_.CorporateContacts,BillingRep,IntakeRep,InitialIntakeRep,ConfirmingRep,InsuranceReviewRep,WoundCareRep,DocumentRep,PayorRep,FacilityAdditionalContact,State,PumpBrand,SpikeSet,Syringe,DrainageBag,ESignPreference' });
                        const lookupService = new LookupService(
                            rootStore.application.baasic.apiClient
                        );
                        // ISG-2961: NikoHealth pricing groups may be unavailable; show the facility without the name.
                        let itemPricingGroup = null;
                        try {
                            const lookups = await lookupService.getLookups("pricingGroup");
                            itemPricingGroup = lookups.pricingGroup.find(
                                (item) => item.id === response.data.pricingGroupId
                            );
                        } catch (err) {
                            itemPricingGroup = null;
                        }

                        response.data.pricingGroup = itemPricingGroup != null ? itemPricingGroup : null;

                        await this.getDeliveryNextDate(response.data.id);
                        await this.getDateOfServiceAndOrderingNextDate(response.data.id);
                        response.data.facilityAreaOfCares = _.sortBy(response.data.facilityAreaOfCares, a=> a.areaOfCare.name);
                        this.facilityStore.setValue(response.data);
                        return response.data;
                    }
                }
            }
        });

        this.scheduleService = new ScheduleService(rootStore.application.baasic.apiClient);

        this.facilityStore = new BaasicDropdownStore({
            filterable: true,
        }, {
            fetchFunc: async (term) => {
                const response = await service.find({ searchQuery: term, rpp: 50 });
                return response.data.item;
            },
            onChange: async (id) => {
                window.location.replace(this.rootStore.routerStore.findRoute("master.app.main.facility.preview").pattern.replace(":id", id));      
            }
        });
    }

    @action.bound
    async getDeliveryNextDate(id) {
        const typeResponse = await this.scheduleService.getTypes();
        const deliveryType = typeResponse && typeResponse.item.find(t => t.abrv == "delivery");
        let nextDeliveryScheduleDate = deliveryType && (await this.scheduleService.find({ rpp: 1, calendarTypeId: deliveryType.id, facilityId: id, dateFrom: this.todaysDate()}));
        if (nextDeliveryScheduleDate && nextDeliveryScheduleDate.data && nextDeliveryScheduleDate.data.item[0]) {
            this.nextDeliveryDate = toUTCDate(nextDeliveryScheduleDate.data.item[0].date);
        }
    }

    @action.bound
    async getDateOfServiceAndOrderingNextDate(id) {
        const typeResponse = await this.scheduleService.getTypes();
        const orderingType = typeResponse && typeResponse.item.find(t => t.abrv == "ordering");
        let nextOrderingScheduleDate = orderingType && (await this.scheduleService.find({ rpp: 1, calendarTypeId: orderingType.id, facilityId: id, dateFrom: this.todaysDate()}));
        if (nextOrderingScheduleDate && nextOrderingScheduleDate.data && nextOrderingScheduleDate.data.item[0]) {
            this.nextOrderingDate = toUTCDate(nextOrderingScheduleDate.data.item[0].date);
            this.dateOfService = toUTCDate(nextOrderingScheduleDate.data.item[0].dateOfService);
        }
    }
    
    todaysDate(){
        return moment().format('YYYY-MM-DD');
    }

    @action.bound
    async getResource(id) {
        await super.getResource(id);
    }

    @action
    setItem(item) {
        this.item = item;
        this.facilityAdditionalContact = _.orderBy(item.facilityAdditionalContact,["inActive",c => c.name.toLowerCase()],"asc");

        this.facilityAdditionalContact =this.facilityAdditionalContact.map(facilityAdditionalContact => {
            let contactDepartments = facilityAdditionalContact.facilityAdditionalContactContactDepartments &&
                facilityAdditionalContact.facilityAdditionalContactContactDepartments.map(i=>i.contactDepartment.name).join(", ");
            return {
                ...facilityAdditionalContact, 
                departments: contactDepartments
            }
        });

        this.rootStore.titleStore.setTitle(this.item ? `Facility Preview - ${this.item.name}` : 'Facility Preview');
    }

    @action.bound
    previewCorporate(id) {
        window.open(this.rootStore.routerStore.findRoute("master.app.main.corporate.preview").pattern.replace(":id", id))
    }
}

export default FacilityPreviewViewStore;
